import script from "./duplicate-contact-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./duplicate-contact-modal.vue?vue&type=script&setup=true&lang=ts"

import "./duplicate-contact-modal.vue?vue&type=style&index=0&id=7768ab4e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7768ab4e"]])

export default __exports__